<template>
    <form-dialog
        :formTitle="title"
        maxWidth="800px"
        @save="Save"
        @cancel="$emit('cancel')"
        :disable-save="!allowSave"
    >
        <v-row dense>
            <v-col dense>
                <medicament-select
                    v-model="medicamentCode"
                    :readonly="code != null"
                ></medicament-select>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col
                dense
                style="display: flex;"
            >
                <v-text-field
                    v-model="unitQuantity"
                    :label="$t('Quantity')"
                    dense
                    outlined
                    hide-details
                ></v-text-field>
                <unit-select
                    v-model="unitId"
                    clearable
                ></unit-select>
            </v-col>
        </v-row>
        <v-row
            dense
            v-for="(convert, index) in convertUnits"
        >
            <v-col
                dense
                style="display: flex;"
            >
                <v-text-field
                    v-model="convert.quantity"
                    :label="$t('Quantity')"
                    dense
                    outlined
                    hide-details
                ></v-text-field>
                <unit-select
                    v-model="convert.unitId"
                    clearable
                ></unit-select>
                <v-btn
                    icon
                    color="error"
                    @click="convertUnits.splice(index, 1)"
                    :disabled="!allowSave"
                >
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col dense>
                <v-btn
                    icon
                    color="success"
                    @click="convertUnits.push({quantity: null, unitId: null})"
                    :disabled="!allowSave"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </form-dialog>
</template>

<script>
import FormDialog from '@/component/form-dialog.vue';
import MedicamentSelect from '@/component/medicament-select.vue';
import UnitSelect from '../unit-select.vue';
import medicamentService from '@/service/medicament-service';

export default {
    components: {
        FormDialog,
        MedicamentSelect,
        UnitSelect,
    },
    props: {
        code: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            medicamentCode: null,
            unitQuantity: null,
            unitId: null,
            convertUnits: [],
            allowSaveToPersonCodes: [],
        };
    },
    computed: {
        userId() {
            return this.$store.state.PersonCode;
        },
        allowSave() {
            return this.allowSaveToPersonCodes
                && this.allowSaveToPersonCodes.length > 0
                && this.allowSaveToPersonCodes.indexOf(this.userId) > -1;
        },
    },
    watch: {
        medicamentCode(val, oldVal) {
            if (val != oldVal) {
                this.LoadConvertUnits();
            }
        },
    },
    mounted() {
        if (this.code) {
            this.medicamentCode = this.code;
        }
        this.LoadPermission();
    },
    methods: {
        LoadPermission() {
            fetch('/config/medicament/unit-set-permission')
                .then(resp => resp.json())
                .then(config => {
                    if (
                        config
                        && config.personCodes
                        && config.personCodes.length > 0
                    ) {
                        this.allowSaveToPersonCodes = config.personCodes;
                    }
                }).catch(() => { });
        },
        LoadConvertUnits() {
            if (this.medicamentCode > 0) {
                medicamentService.getDefaultUnit(this.medicamentCode)
                    .then((response) => {
                        this.unitId = response.unitId;
                        this.unitQuantity = response.unitQuantity;
                    });
                medicamentService.getConvertUnits(this.medicamentCode)
                    .then((response) => {
                        this.convertUnits = response.data;
                    });
            } else {
                this.unitId = null;
                this.unitQuantity = null;
                this.convertUnits = [];
            }
        },
        Save() {
            if (!this.allowSave) {
                return;
            }
            medicamentService.setUnit({
                code: this.medicamentCode,
                default: {
                    unitId: this.unitId,
                    unitQuantity: +this.unitQuantity
                },
                converts: this.convertUnits.map((convert) => {
                    return {
                        unitQuantity: convert.quantity,
                        unitId: convert.unitId,
                    };
                })
            }).then(() => {
                this.$emit('save', {
                    medicamentCode: this.medicamentCode,
                    unitId: this.unitId,
                    unitQuantity: +this.unitQuantity
                });
            });
        }
    },
}
</script>